module.exports = __webpack_public_path__ + "img/noGood.02cfca3e.png";